import { NavLink } from 'react-router-dom'

// Tabs across the top of the Accounting pages.
export default function AccountingTabs() {
  const tabs = [
    { to: '/accounting', label: 'Summary', end: true },
    { to: '/accounting/journal-entries', label: 'Journal entries' },
    { to: '/accounting/transaction-types', label: 'Transaction types' },
    { to: '/accounting/ap/matching', label: 'Vendor invoices' },
    { to: '/accounting/assets', label: 'Fixed assets' },
    { to: '/accounting/prepaids', label: 'Prepaids' },
    { to: '/accounting/month-end', label: 'Month-end close' },
  ]
  return (
    <nav className="section-tabs" aria-label="Accounting">
      {tabs.map(({ to, label, end }) => <NavLink key={to} to={to} end={end}>{label}</NavLink>)}
    </nav>
  )
}
